import { ProductOP, ProductsResponseOP } from '@cemex-core/cmx-api';
import { ProductBalanceContractsSelected, ProductQtySelected } from '../../../models/products.interface';
import { ADTProductActions as AdtProductActions, AdtProductsActionTypes } from '../../actions/products.actions';

/**
 * Admixture Products Store Interface
 */
export interface ProductsState {
    loading: boolean;
    products: ProductOP[];
    productQtySelected: ProductQtySelected[];
    productContractBalancesSelected: ProductBalanceContractsSelected[];
    selectedProducts: { [formID: string]: ProductOP };
}

/**
 * Initial state of Admixture Products Store
 */
export const initialState: ProductsState = {
    loading: false,
    products: undefined,
    productQtySelected: undefined,
    productContractBalancesSelected: undefined,
    selectedProducts: undefined,
};

/**
 * @description Updates the state of Admicture products
 * @param {ProductsState} state Products state
 * @param {AdtProductActions} action Products actions
 * @returns {ProductsState}
 */
export function adtProductsReducer(state = initialState, action: AdtProductActions): ProductsState {
    switch (action.type) {
        case AdtProductsActionTypes.FETCH_PRODUCTS: {
            return {
                ...state,
                loading: true,
            } as ProductsState;
        }
        case AdtProductsActionTypes.LOAD_PRODUCTS_RESPONSE: {
            const productsResponse = action.payload as ProductsResponseOP;
            return {
                ...state,
                products: [...productsResponse.products],
                loading: false,
            } as ProductsState;
        }
        case AdtProductsActionTypes.LOAD_SELECTED_PRODUCT: {
            const selectedProducts = action.payload as { [formID: string]: ProductOP };
            return {
                ...state,
                selectedProducts: { ...state.selectedProducts, ...selectedProducts },
            } as ProductsState;
        }
        case AdtProductsActionTypes.RESET_PRODUCTS: {
            return {
                ...initialState,
            };
        }
        default: {
            return state;
        }
    }
}
